<script>
  export let name = '';
  export let tooltip_text = '';
  export let id = '';
  export let tier_level = '';
  export let tier_restriction = '';
  export let region = '';
</script>

<div {id}>
  <p class="tooltip__header">{name} County</p>
  <p class="tooltip__value closures_val">
    {region} region
  </p>
  <p class="tooltip__value closures_val">
    Tier {tier_level} &bull; {tier_restriction} risk
  </p>
  <p class="reopening_tooltip_text">
    {tooltip_text}
  </p>
</div>
